// extracted by mini-css-extract-plugin
export default {"overrideLayoutOpen":"StretchContainer_overrideLayoutOpen__s-07D"};